import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { RoleReadDTO } from './dto';
import { GetManyUnpaged } from './types';

const RESOURCE_PATH = 'roles';

export const getActivityApprovalTypes: GetManyUnpaged<{}, RoleReadDTO> = async ({ config } = {}) =>
    client
        .get(buildPath([RESOURCE_PATH, 'activity-approval-types']), config)
        .then((response: AxiosResponse) => response.data);
